import DataSharing from './DataSharing'

export default DataSharing
